export default text => `${text}%`;
